import React, { useState } from "react"
import { useTranslation } from "react-i18next"

import { convertOrderCombosToCartCombos } from "utils"
import KtOrderNoteCardDropDown from "./KtOrderNoteCardDropDown"
import classes from "./KtOrderNoteCard.module.scss"
import clsx from "clsx"

const KtOrderNoteCard = props => {
  const {
    tableNotConfirmedOrder,
    setTableNotConfirmedOrders
  } = props

  const [t, i18n] = useTranslation()

  const [openDropdown, setOpenDropdown] = useState(false)

  const tableOrderItems =
    tableNotConfirmedOrder.items.filter(item =>
      !item.comboSet
    )

  const tableCombos =
    convertOrderCombosToCartCombos(
      tableNotConfirmedOrder.items
    )

  const isLtr = i18n.dir(i18n.language) === "ltr"

  const getPortionLabel = portion => ({
    firstHalf: i18n.language === "fa" ? "نیمه اول: " : "First half: ",
    secondHalf: i18n.language === "fa" ? "نیمه دوم: " : "Second half: "
  })[portion] || ""

  return (
    <div
      className={clsx(
        classes["card"],
        isLtr && classes["card-ltr"]
      )}
    >
      <div
        className={clsx(
          classes["order"],
          isLtr && classes["order-ltr"]
        )}
      >
        <div className={classes["code"]}>
          {t("سفارش")} {tableNotConfirmedOrder.code}
        </div>
        {tableOrderItems.map((orderItem, i) =>
          <div
            key={i}
            className={classes["text-order"]}
          >
            <div>
              <b>
                {orderItem.quantity} x
              </b>
              <span>
                {" "}{orderItem.foodName}{" "}
              </span>
              <span>
                {!orderItem.isSimple ? `(${orderItem.option.name})` : ""}
              </span>
            </div>
            {orderItem.orderItemSpecifications.map(orderItemSpecification =>
              orderItemSpecification.specificationItems.map(specificationItem =>
                <div
                  key={`${specificationItem.builderStepKey || "whole"}-${specificationItem.specificationItemId}`}
                  className={classes["extraFood"]}
                >
                  <strong>{getPortionLabel(specificationItem.portion)}</strong>
                  {specificationItem.name}
                </div>
              )
            )}
          </div>
        )}

        {tableCombos.map((combo, cIndex) =>
          <div
            key={cIndex}
            className={classes["combo"]}
          >
            <div className={classes["comboNameContainer"]}>
              <span className={classes["comboName"]}>
                {t("بسته_ترکیبی")}{" "}
              </span>
              <b className={classes["comboCode"]}>
                {combo.foodName}
              </b>
            </div>
            <div className={classes["comboItems"]}>
              {combo.items.map((comboItem, comboItemIndex) =>
                <div
                  key={comboItemIndex}
                  className={classes["text-combo"]}
                >
                  <b>
                    {comboItem.quantity}x
                  </b>
                  <span>
                    {" "}{comboItem.foodName}{" "}
                  </span>
                  <span>
                    {!comboItem.isSimple ? `(${comboItem.optionName})` : ""}
                  </span>
                </div>
              )}
            </div>
          </div>
        )}
      </div>

      <KtOrderNoteCardDropDown
        tableNotConfirmedOrder={tableNotConfirmedOrder}
        setTableNotConfirmedOrders={setTableNotConfirmedOrders}
        openDropdown={openDropdown}
        setOpenDropdown={setOpenDropdown}
      />
    </div>
  )
}

export default KtOrderNoteCard
